"use strict";
import {
  DocumentPODDisposition,
  DocumentReferenceMatchDisposition
} from "../data/types/Pb";
export function getLoadRelationshipForDocument(document, load, documentLoadRelationships) {
  var _a;
  if (!documentLoadRelationships || !load) {
    return null;
  }
  return (_a = documentLoadRelationships.find(
    (r) => r.document_id === document.id && r.load_state_id === load.id
  )) != null ? _a : null;
}
export function documentHasReferenceMatchForLoad(document, load, documentLoadRelationships) {
  var _a;
  const relationship = getLoadRelationshipForDocument(
    document,
    load,
    documentLoadRelationships
  );
  if (!relationship) {
    return (_a = document.has_reference_number) != null ? _a : false;
  }
  return relationship.reference_match_disposition === DocumentReferenceMatchDisposition.DocumentReferenceMatchDispositionKnownMatch;
}
export function documentHasMissingReferenceMatchForLoad(document, load, documentLoadRelationships) {
  const relationship = getLoadRelationshipForDocument(
    document,
    load,
    documentLoadRelationships
  );
  if (!relationship) {
    return false;
  }
  return relationship.reference_match_disposition === DocumentReferenceMatchDisposition.DocumentReferenceMatchDispositionKnownNoMatch;
}
export function isPodForLoad(document, load, documentLoadRelationships) {
  var _a;
  const relationship = getLoadRelationshipForDocument(
    document,
    load,
    documentLoadRelationships
  );
  if (!relationship) {
    return (_a = document.is_pod) != null ? _a : false;
  }
  return relationship.pod_disposition === DocumentPODDisposition.DocumentPODDispositionKnownPOD;
}
